import React from "react";

const Navbar = ({ user, onLogout }) => {
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">User Management System</div>
        <div className="navbar-user">
          <span>Welcome, {user.username}</span>
          <span
            className={`btn ${
              user.role === "superadmin"
                ? "btn-warning"
                : user.role === "admin"
                ? "btn-danger"
                : "btn-primary"
            }`}
            style={{ padding: "5px 10px", fontSize: "12px" }}
          >
            {user.role === "superadmin"
              ? "SUPER ADMIN"
              : user.role === "admin"
              ? "BUSINESS"
              : user.role.toUpperCase()}
          </span>
          <button className="btn btn-secondary" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
